import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "orbital_token";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export const api = axios.create({ baseURL: API, timeout: 20000 });

api.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      tokenStore.clear();
    }
    return Promise.reject(err);
  },
);

export const FIAT_SYMBOLS = { USD: "$", CAD: "CA$", EUR: "€" };
export const CRYPTO_SYMBOLS = ["BTC", "ETH", "SOL", "XRP", "BNB", "USDC", "DOGE"];
export const FIATS = ["USD", "CAD", "EUR"];

export const formatFiat = (v, ccy = "USD", digits = 2) => {
  const n = Number(v || 0);
  const sym = FIAT_SYMBOLS[ccy] || "";
  return `${sym}${n.toLocaleString(undefined, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}`;
};

export const formatCrypto = (v, digits = 6) => {
  const n = Number(v || 0);
  return n.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: digits,
  });
};

export const formatPct = (v) => {
  const n = Number(v || 0);
  const sign = n >= 0 ? "+" : "";
  return `${sign}${n.toFixed(2)}%`;
};
